<template>
  <el-card v-loading="loading">
    <el-form label-width="250px">
      <el-form-item
        label="Enable Credit Card Fee"
      >
        <el-switch
          v-model="creditCardFee.enabled"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="Add Credit Card Fee"
          inactive-text="No Credit Card Fee"
          :disabled="!hasAccess"
          @change="setCreditCardFeeFlag"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="Credit Card Fee in percentage">
        <el-input-number
          v-if="creditCardFee && creditCardFee.enabled"
          v-model.number="creditCardFee.fee"
          :precision="2"
          :max="25"
          :min="0"
          :disabled="!hasAccess"
          @change="enableSaveButton"
        >
        </el-input-number>
        <el-button v-if="hasAccess" :disabled="!editForm" @click="saveCreditCardFeeValue">
          Save
        </el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import axios from 'axios';
import { ADMIN_API_BASE } from '../env';

export default {
  name: 'FacilityCreditCardFeeSettings',
  props: { facility: { type: String, required: true } },
  async mounted() {
    await this.getFacilityCreditCardFee();
    this.loading = false;
  },
  computed: {
    hasAccess() {
      const roles = this.$keycloak.tokenParsed.realm_access.roles;
      if (roles.includes('level_1')) {
        return true;
      }
      return false;
    },
  },
  watch: {
    async facility() {
      await this.getFacilityCreditCardFee();
    },
  },
  data() {
    return {
      loading: true,
      creditCardFee: {
        enabled: false,
        fee: 0,
      },
      editForm: false,
    };
  },
  methods: {
    enableSaveButton() {
      this.editForm = true;
    },
    async saveCreditCardFeeValue() {
      await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
        creditCardFee: this.creditCardFee,
        enabled: this.creditCardFee.enabled,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.loading = true;
      await this.getFacilityCreditCardFee();
      this.loading = false;
      this.$message.success({
        title: 'Success',
        message: 'Successfully updated Credit Card Fee.',
      });
    },
    async getFacilityCreditCardFee() {
      this.loading = true;
      const response = await axios.get(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.creditCardFee = response.data.creditCardFee;

      if (!this.creditCardFee) {
        this.creditCardFee = {
          enabled: false,
          fee: 0,
        };
      }
      this.loading = false;
    },
    async setCreditCardFeeFlag(flag) {
      try {
        await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
          creditCardFee: {
            enabled: flag,
            fee: this.creditCardFee.fee,
          },
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.loading = true;
        await this.getFacilityCreditCardFee();
        this.loading = false;
        this.$message.success({
          title: 'Success',
          message: flag ? 'Credit Card Fee Enabled successfully' : 'Credit Card fee disabled successfully',
        });
      } catch (err) {
        this.$message.error({
          title: 'Error',
          message: err.message ? err.message : err.resposne.data.toUpperCase(),
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FacilityCreditCardFee.vue